// Central bilingual content for Yellow5 (English default, French secondary)

export const IMAGES = {
  hero: "https://images.pexels.com/photos/8533140/pexels-photo-8533140.jpeg",
  heroSlides: [
    "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/qjxipmab_iStock-1405788565.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/umg3l9m4_iStock-1294339614.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/ddbzmuvh_Img-Banner-03.jpg",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/hn68tqfu_iStock-1417391937.webp",
  ],
  lifeScience: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/xghcarsv_life%20sciences%20page%20services%20%2B%20pharma%20%26%20biotech%20page%20acceuil.png",
  engineering: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/ficwtctv_Engineering%20page%20services.jpg",
  legiaPark: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/7zc7jnc7_image.webp",
  sigle: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/wz8arhz0_YELLOW5_Sigle_CMYK_Color_White.jpg",
  fullLogo: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/8a3m5kio_Yellow5_Logo_Layout_Vecto-02.webp",
  gallery: [
    "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/ff1s8zbx_Image%20%283%29.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/ky4dzoc7_Image%20%282%29.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/so36sy7i_image%20%281%29.jpg",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/efdgu9le_image%20%285%29.webp",
    "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/t930uib1_image%20%282%29.webp",
  ],
  sectors: {
    pharma: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/xghcarsv_life%20sciences%20page%20services%20%2B%20pharma%20%26%20biotech%20page%20acceuil.png",
    medtech: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/ntktul5k_medtech%20page%20acceuil.png",
    food: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/3b1gwido_agroalimentaire%20page%20acceuil.png",
    aerodef: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/6x1bxgfa_a%C3%A9ronautique%20%26%20defence%20page%20acceuil.png",
    chimie: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/wde2nrgm_Chimie%20%26%20mat%C3%A9riaux%20page%20acceuil.png",
    industrie: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/aklsiaxk_Industrie%20%26%20manufacturing%20%20page%20acceuil.png",
  },
};

export const CLIENT_TESTIMONIALS = [
  {
    name: "SGS",
    logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/eezcxcy5_images%20%282%29.png",
    quote: "Our collaboration is dynamic and constructive. Yellow5 has clearly understood our expectations in terms of both skills and personality. We have regular exchanges that enable us to align our points of view. As a result, we've been able to recruit quickly and efficiently.",
  },
  {
    name: "Diagam",
    cls: "max-h-14 max-w-[180px]",
    logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/j2n0tap7_diagam_s_a_logo.jpg",
    quote: "I had an excellent experience with this agency in 2024. Yellow5 was incredibly helpful throughout the process. Always present and remarkably patient, they were able to answer all my questions and support me with professionalism. Thanks to their support, I was able to move forward confidently in my search. I highly recommend this agency for their seriousness and dedication!",
  },
  {
    name: "Hephaistos Pharma",
    cls: "max-h-14 max-w-[180px]",
    logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/yhbd7nz3_hephaistos.png",
    quote: "Yellow5 helped us recruit our team in Liège during the opening of our Belgian branch. Not only were the profiles found very relevant, but Yellow5 also provided assistance with drafting contracts and identifying available support in Belgium.",
  },
  {
    name: "Orthodyne",
    cls: "max-h-14 max-w-[180px]",
    logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/klqh0vr7_image.png",
    quote: "Special mention for our brand-new collaboration: you immediately grasped the complexity and stakes of the toughest position we had to fill… and found the rare gem.",
  },
];

// Partners are language-neutral (logo names + optional Clearbit domain)
export const PARTNERS = [
  { name: "Ortis", domain: "ortis.be" },
  { name: "GSK", domain: "gsk.com" },
  { name: "Viatris", domain: "viatris.com" },
  { name: "HEX Group", domain: null },
  { name: "OncoDNA", domain: "oncodna.com" },
  { name: "Astel Medica", domain: "astelmedica.com" },
  { name: "Boiron", domain: "boiron.com" },
  { name: "PDC*line Pharma", domain: "pdc-line-pharma.com" },
  { name: "Inula", domain: "inula.com" },
  { name: "iStar Medical", domain: "istar-medical.com" },
  { name: "Sterigenics", domain: "sterigenics.com" },
  { name: "IBA", domain: "iba-worldwide.com" },
  { name: "Eurogentec", domain: "eurogentec.com" },
  { name: "Sol Group", domain: "solgroup.com" },
  { name: "EyeD Pharma", domain: "eyedpharma.com" },
  { name: "Prefer", domain: null },
  { name: "Lutosa", domain: "lutosa.com" },
  { name: "Orthodyne", domain: "orthodyne.be" },
  { name: "Revatech", domain: "revatech.be" },
  { name: "Recyfuel", domain: "recyfuel.be" },
  { name: "Mockel", domain: "mockel.eu" },
  { name: "Theon Group", domain: "theon.com" },
];

export const CONTACT_PEOPLE = [
  { name: "Laurent Haupert", roleKey: "founder", email: "lha@yellow5.be", phone: null, photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/rdqj33mn_Laurent.jpg" },
  { name: "Julien Hildebrand", roleKey: "cofounder", email: "jhi@yellow5.be", phone: null, photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/1iu5x62b_Julien.jpg" },
  { name: "Robin Josse", roleKey: "bdPharma", email: "rjo@yellow5.be", phone: "+32 470 18 47 26", photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/w7fg6zl2_Robin.jpg" },
  { name: "Antoine Bockiau", roleKey: "bdEng", email: "abo@yellow5.be", phone: "+32 498 03 46 71", photo: "https://customer-assets-wrfwihn1.emergentagent.net/job_talent-hub-818/artifacts/ne3efskr_Antoine.jpg" },
];

export const SECTOR_LABELS = {
  "Pharma & Biotech": { en: "Pharma & Biotech", fr: "Pharma & Biotech" },
  "MedTech": { en: "MedTech", fr: "MedTech" },
  "Agroalimentaire": { en: "Food", fr: "Agroalimentaire" },
  "Aéronautique & Défense": { en: "Aerospace & Defence", fr: "Aéronautique & Défense" },
  "Chimie & Matériaux": { en: "Chemicals & Materials", fr: "Chimie & Matériaux" },
  "Industrie & Manufacturing": { en: "Industry & Manufacturing", fr: "Industrie & Manufacturing" },
};

export const PROVINCES = [
  "Anvers", "Brabant flamand", "Brabant wallon", "Flandre occidentale",
  "Flandre orientale", "Hainaut", "Liège", "Limbourg", "Luxembourg",
  "Namur", "Bruxelles-Capitale",
];

export const PROVINCE_LABELS = {
  "Anvers": { en: "Antwerp", fr: "Anvers" },
  "Brabant flamand": { en: "Flemish Brabant", fr: "Brabant flamand" },
  "Brabant wallon": { en: "Walloon Brabant", fr: "Brabant wallon" },
  "Flandre occidentale": { en: "West Flanders", fr: "Flandre occidentale" },
  "Flandre orientale": { en: "East Flanders", fr: "Flandre orientale" },
  "Hainaut": { en: "Hainaut", fr: "Hainaut" },
  "Liège": { en: "Liège", fr: "Liège" },
  "Limbourg": { en: "Limburg", fr: "Limbourg" },
  "Luxembourg": { en: "Luxembourg", fr: "Luxembourg" },
  "Namur": { en: "Namur", fr: "Namur" },
  "Bruxelles-Capitale": { en: "Brussels-Capital", fr: "Bruxelles-Capitale" },
};

export const provinceLabel = (p, lang) => (p && PROVINCE_LABELS[p] && PROVINCE_LABELS[p][lang]) || p || "";
export function formatProvince(p, lang) {
  if (!p) return "";
  const label = provinceLabel(p, lang);
  if (p === "Bruxelles-Capitale") return label; // no "Province of" prefix
  return lang === "en" ? `${label} Province` : `Province de ${label}`;
}

export function formatPublishedDate(iso, lang) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const locale = lang === "en" ? "en-GB" : "fr-FR";
  const formatted = new Intl.DateTimeFormat(locale, { year: "numeric", month: "long", day: "numeric" }).format(d);
  return lang === "en" ? `Published on ${formatted}` : `Publié le ${formatted}`;
}

export const CONTRACT_LABELS = {
  CDI: { en: "Permanent", fr: "CDI" },
  CDD: { en: "Fixed-term", fr: "CDD" },
  Freelance: { en: "Freelance", fr: "Freelance" },
  Interim: { en: "Temporary", fr: "Intérim" },
};

export const sectorLabel = (s, lang) => (SECTOR_LABELS[s] && SECTOR_LABELS[s][lang]) || s;
export const contractLabel = (c, lang) => (CONTRACT_LABELS[c] && CONTRACT_LABELS[c][lang]) || c;
export function jobField(job, base, lang) {
  if (lang === "en") {
    const en = job[`${base}_en`];
    if (Array.isArray(en) ? en.length > 0 : Boolean(en)) return en;
  }
  return job[base];
}

export const PAGE_META = {
  en: {
    home: {
      title: "Yellow5 — Consulting & recruitment for regulated industries",
      description:
        "Yellow5 is a Belgian consulting and recruitment firm dedicated to highly regulated industries: pharma, biotech, medtech, aerospace, chemicals, industry and food across the BeNeLux.",
    },
    services: {
      title: "Services — Consulting & recruitment | Yellow5",
      description:
        "Yellow5 services: Life Sciences (QA, QC, QP, CSV, Regulatory Affairs) and Engineering (project, process, R&D, automation). Consulting on payroll or freelance, and permanent placement.",
    },
    about: {
      title: "About Yellow5 — Experts for regulated industries",
      description:
        "Founded in 2022 in Liège by industrial pharmacists, Yellow5 brings together ~20 experts and a network of +5,000 activable candidates for the most demanding regulated environments.",
    },
    jobs: {
      title: "Jobs — Openings in regulated industries | Yellow5",
      description:
        "Discover Yellow5 job openings in pharma, biotech, medtech, aerospace, chemicals, industry and food. Permanent, fixed-term, freelance and interim contracts across the BeNeLux.",
    },
    apply: {
      title: "Spontaneous application — Send your CV | Yellow5",
      description:
        "No opening matches your profile? Send your CV to Yellow5. Our team reviews every qualified profile in regulated environments and gets back to you when an opportunity matches.",
    },
    contact: {
      title: "Contact Yellow5 — Liège, BeNeLux",
      description:
        "Reach out to Yellow5 for a recruitment need, a consulting assignment or a question. Offices at LégiaPark, Liège. Our team replies within 48 hours.",
    },
    jobDetailFallback: {
      title: "Job opening — Yellow5",
      description: "Discover this opportunity in a regulated industry with Yellow5.",
    },
  },
  fr: {
    home: {
      title: "Yellow5 — Consultance & recrutement pour industries régulées",
      description:
        "Yellow5 est un cabinet belge de consultance et recrutement dédié aux industries hautement réglementées : pharma, biotech, medtech, aéronautique, chimie, industrie et agroalimentaire dans le BeNeLux.",
    },
    services: {
      title: "Services — Consultance & recrutement | Yellow5",
      description:
        "Services Yellow5 : Life Sciences (QA, QC, QP, CSV, Affaires réglementaires) et Engineering (projet, procédés, R&D, automatisation). Consultance en payroll ou freelance, et placement permanent.",
    },
    about: {
      title: "À propos de Yellow5 — Experts pour les industries régulées",
      description:
        "Fondée en 2022 à Liège par des pharmaciens industriels, Yellow5 réunit environ 20 experts et un réseau activable de +5 000 candidats pour les environnements régulés les plus exigeants.",
    },
    jobs: {
      title: "Offres d'emploi — Industries régulées | Yellow5",
      description:
        "Découvrez les offres Yellow5 dans la pharma, biotech, medtech, aéronautique, chimie, industrie et agroalimentaire. CDI, CDD, freelance et intérim dans le BeNeLux.",
    },
    apply: {
      title: "Candidature spontanée — Envoyez votre CV | Yellow5",
      description:
        "Aucune offre ne correspond à votre profil ? Envoyez votre CV à Yellow5. Notre équipe étudie chaque profil qualifié dans les environnements régulés et revient vers vous dès qu'une opportunité correspond.",
    },
    contact: {
      title: "Contact Yellow5 — Liège, BeNeLux",
      description:
        "Contactez Yellow5 pour un besoin de recrutement, une mission de consultance ou une question. Bureaux au LégiaPark, Liège. Notre équipe répond sous 48h.",
    },
    jobDetailFallback: {
      title: "Offre d'emploi — Yellow5",
      description: "Découvrez cette opportunité dans une industrie régulée avec Yellow5.",
    },
  },
};

export const T = {
  en: {
    lang: { switch: "FR", label: "English" },
    nav: { home: "Home", services: "Services", about: "About", jobs: "Jobs", contact: "Contact", cta: "View jobs" },
    hero: {
      kicker: "Created by scientists, driven by talents",
      lines: ["Experts for the"],
      line2: "most demanding",
      line3: "environments.",
      subtitle: "Consulting & recruitment for pharma, medtech, aerospace, chemicals, industry and food.",
      ctaPrimary: "View jobs",
      ctaSecondary: "Spontaneous application",
    },
    stats: [
      { k: "6", l: "Regulated sectors" },
      { k: "BeNeLux", l: "Belgium, Netherlands, Luxembourg" },
      { k: "2", l: "Consulting & recruitment" },
    ],
    intro: {
      title: ["Highly controlled", "& regulated", "industries"],
      text:
        "In a world where compliance and precision are critical, Yellow5 partners with companies in highly regulated industries to meet their challenges. We provide expert guidance and practical solutions to navigate the complexity of the pharmaceutical, engineering and food sectors — helping you stay compliant while driving innovation.",
      link: "Discover our services",
    },
    sectors: {
      kicker: "Our sectors",
      title: ["Environments where", "rigour is the norm."],
      desc: "We operate where regulation shapes every technical and human decision.",
      names: { pharma: "Pharma & Biotech", medtech: "MedTech", food: "Food", aerodef: "Aerospace & Defence", chimie: "Chemicals & Materials", industrie: "Industry & Manufacturing" },
    },
    manifesto: {
      title: ["How we", "recruit"],
      chapters: [
        { n: "01", t: "Scientific expertise first", d: "Founded by scientists, Yellow5 understands the technical and regulatory demands of your fields. We speak your language." },
        { n: "02", t: "Regulated environments only", d: "GMP, ISO, HACCP, IEC. We operate exclusively where compliance and precision are non-negotiable." },
        { n: "03", t: "Engineers & technicians", d: "From the field to the executive committee, we cover all the key functions of your high-requirement environments." },
      ],
    },
    latestJobs: { title: "Recent openings", all: "All jobs" },
    partners: { kicker: "They trusted us", title: "Our partners", yourBrand: ["Your brand", "here?"], become: "Become a partner" },
    ctaHome: { title: ["A project in mind?"], accent: "Let's talk.", text: "Whether you are recruiting or looking for your next challenge, our team is here to listen.", button: "Contact us" },
    footer: {
      tagline: "Consulting & recruitment for regulated environments. Created by scientists, driven by talents.",
      nav: "Navigation", services: "Services", about: "About", jobs: "Jobs", spontaneous: "Spontaneous application", admin: "Admin area",
      contact: "Contact", linkedin: "Follow us on LinkedIn", office: "Our offices", rights: "All rights reserved.", specialist: "Regulated Environments Specialist",
      privacy: "Privacy policy", manageCookies: "Manage cookies",
    },
    services: {
      kicker: "Our services",
      title: ["Consulting &", "recruitment"],
      subtitle: "Two complementary areas of expertise to support high-requirement industries.",
      model: {
        intro: "Two complementary areas of expertise to support high-requirement industries.",
        consulting: { t: "Consulting", d: "We provide specialists for your temporary needs or projects — either as Yellow5 consultants on our payroll, or as freelancers." },
        recruitment: { t: "Recruitment (permanent placement)", d: "We identify and integrate the right person directly into your team, on a permanent contract." },
      },
      needTitle: "A specific need?",
      needText: "Let's talk about your project and your compliance challenges.",
      contact: "Contact us",
      items: [
        {
          id: "life-science", label: "Life Sciences", tagline: "Pharmaceutical, biotech & medtech",
          desc: "From design to production, we help you meet regulatory and quality standards while improving operational efficiency.",
          list: ["QA", "QC", "QMS", "Qualified Person (QP)", "Responsible Person (Distribution)", "CSV", "Qualification & Validation", "Clinical", "Pharmacovigilance", "Regulatory Affairs", "Audits"],
        },
        {
          id: "engineering", label: "Engineering", tagline: "Chemicals & materials, industry & manufacturing, aerospace & defence, food",
          desc: "In a sector where process optimisation and technical compliance are key, we provide profiles and end-to-end services.",
          list: ["Designers", "Project Engineers & Managers", "R&D Engineers", "Production / Maintenance Engineers", "Process Engineers", "End-to-end project management", "Feasibility studies & ISO compliance", "Innovative and sustainable process implementation", "Risk & requirements analysis", "Automation", "Maintenance technician", "Electromechanic"],
        },
      ],
    },
    about: {
      kicker: "About",
      title: ["Experts serving", "high-requirement", "industries"],
      paragraphs: [
        "Founded in 2022 by two industrial pharmacists, Yellow5 is a consulting and recruitment firm specialising in highly regulated, innovation-driven industries.",
        "In early 2023, a business engineer joined the team to grow our activities and strengthen our commitment: connecting top talent with leading organisations.",
        "Since then, the team has kept growing. The company now brings together a network of around twenty people, blending internal employees and freelancers. Since 2024, Yellow5 has moved its offices to LégiaPark.",
      ],
      stats: [{ k: "2022", l: "Founded" }, { k: "~20", l: "Experts currently on assignment" }, { k: "+5000", l: "An activable network of thousands of candidates" }, { k: "LégiaPark", l: "Our offices" }],
      galleryTitle: "People at the heart",
      dna: {
        kicker: "Our DNA", title: "Five, like the fingers of a hand",
        paragraphs: [
          "Our name, Yellow5, reflects our philosophy: Five, like the five fingers of a hand — a symbol of collaboration, trust and synergy between our clients and the experts we connect them with.",
          "At the crossroads of technology, compliance and innovation, we extend our hand as a reliable partner, with tailored solutions to support your most ambitious projects and build the right team.",
          "Yellow5 is about creating value by developing our Talents in a complex, demanding, high value-added environment while keeping people at the heart of our organisation. If our heart beats for our Talents, our DNA remains Science.",
        ],
      },
      mission: {
        kicker: "Mission & Values", title: "Tackling complexity",
        text: "Our mission is clear: tackling complexity head-on to ensure your innovative achievements. To deliver on this promise, we rely on strong values.",
        values: [
          { n: "01", t: "Excellence", d: "We pursue excellence in every solution, ensuring the highest standards in complex and regulated environments." },
          { n: "02", t: "Transparency", d: "Transparency shapes the way we work, building trust and clarity in every collaboration." },
          { n: "03", t: "Commitment", d: "Our deep commitment drives us to support our clients and talents with dedication and purpose." },
          { n: "04", t: "Collaboration", d: "We believe in the power of collaboration — because progress happens when expertise, innovation and people come together." },
        ],
      },
      experts: {
        kicker: "Expert network", title: ["They talk", "about us"], desc: "Experts from our network share their experience working with Yellow5.",
        joinTitle: "Join our talent network", joinCta: "Spontaneous application",
        list: [
          { name: "Nicolas J.", role: "CQV Expert", quote: "Delighted to have been approached by Yellow5 for a freelance collaboration. After a year, several collaborations have been completed successfully, including one now starting with CHU Liège. A true local player, Yellow5 excels at connecting the right person with the right opportunity, with genuine passion, patience and consistency. Their radiant simplicity in a complex field is truly refreshing." },
          { name: "Anne V.", role: "Qualified Person", quote: "Y5 supports me throughout my projects and is very attentive to my mission preferences. A small organisation that values each individual for their skills and expertise. At Y5, performance and client satisfaction are never separated from kindness." },
          { name: "Nelly S.", role: "Qualified Person, Auditor", quote: "A real pleasure to work with Yellow5: clear, efficient and transparent communication. A question? There is always someone at the other end of the line. Do it again? Absolutely. And that positive attitude — a true bonus." },
          { name: "Jean-Marc T.", role: "Qualified Person", quote: "An excellent understanding of the life sciences sector, optimal responsiveness and rigorous case follow-up characterise Yellow5's method. The missions proposed are perfectly targeted and suited to the consultant's skills. An extremely fruitful, positive collaboration that I hope will continue." },
        ],
      },
    },
    contact: {
      kicker: "Contact", title: ["Let's talk", "together."],
      subtitle: "A recruitment need, a consulting assignment or a simple question? Our team replies within 48 hours.",
      office: "Our offices", address: "LégiaPark, Boulevard Patience et Beaujonc 3, 4000 Liège",
      roles: { founder: "Founder", cofounder: "Co-founder", bdPharma: "Business Development & Recruitment Associate — Pharma / MedTech", bdEng: "Business Development & Recruitment Consultant — Engineering" },
      form: { name: "Full name *", email: "Email *", company: "Company", message: "Your message *", submit: "Send message", sending: "Sending…", successTitle: "Message sent", successText: "Thank you, we will get back to you very soon.", errRequired: "Name, email and message are required.", ok: "Message sent!" },
    },
    jobs: {
      kicker: "Join us", title: ["Job", "openings"], allSectors: "All sectors", allProfiles: "All profiles",
      engineer: "Engineer", technician: "Technician", loading: "Loading…",
      emptyTitle: "No opening for this filter", emptyText: "Try a spontaneous application — we review every qualified profile.",
    },
    jobDetail: { back: "All jobs", description: "Description", requirements: "Profile sought", apply: "Apply for this role", notFound: "Opening not found.", backLink: "Back to jobs", loading: "Loading…" },
    apply: { kicker: "Spontaneous application", title: ["Your", "next", "challenge."], text: "No opening matches your profile? Send us your CV. Our team reviews it carefully and gets back to you as soon as an opportunity matches your profile in regulated environments.", aiTitle: "Smart CV analysis", aiText: "Skills, experience and sector detected automatically for faster matching." },
    login: { area: "Admin area", title: "Sign in", email: "Email", password: "Password", submit: "Sign in", ok: "Signed in", },
    appForm: { role: "Role", name: "Full name *", email: "Email *", phone: "Phone", message: "Message (optional)", submit: "Send application", analysing: "Sending…", cvRequired: "Please attach your CV.", nameEmail: "Name and email required.", successTitle: "Application received", successText: "Thank you {name}. Our team is reviewing your profile and will get back to you shortly.", ok: "Application sent!", dropTitle: "Drop your CV here or click to browse", dropSub: "PDF, DOC or DOCX · max 10 MB" },
  },

  fr: {
    lang: { switch: "EN", label: "Français" },
    nav: { home: "Accueil", services: "Services", about: "À propos", jobs: "Offres", contact: "Contact", cta: "Voir les offres" },
    hero: {
      kicker: "Created by scientists, driven by talents",
      lines: ["Des experts pour"],
      line2: "les environnements",
      line3: "les plus exigeants.",
      subtitle: "Consultance & recrutement pour la pharma, medtech, aéro, chimie, industrie et agroalimentaire.",
      ctaPrimary: "Voir les offres",
      ctaSecondary: "Candidature spontanée",
    },
    stats: [
      { k: "6", l: "Secteurs régulés" },
      { k: "BeNeLux", l: "Belgique, Pays-Bas, Luxembourg" },
      { k: "2", l: "Consultance & recrutement" },
    ],
    intro: {
      title: ["Industries hautement", "contrôlées &", "réglementées"],
      text:
        "Dans un monde où la conformité et la précision sont essentielles, Yellow5 accompagne les entreprises des industries hautement réglementées pour relever leurs défis. Nous offrons une expertise pointue et des solutions concrètes pour naviguer dans la complexité des secteurs pharmaceutique, de l'ingénierie et de l'agroalimentaire — afin de maintenir votre conformité tout en stimulant l'innovation.",
      link: "Découvrir nos services",
    },
    sectors: {
      kicker: "Nos secteurs",
      title: ["Des environnements où", "l'exigence est la norme."],
      desc: "Nous intervenons là où la réglementation façonne chaque décision technique et humaine.",
      names: { pharma: "Pharma & Biotech", medtech: "MedTech", food: "Agroalimentaire", aerodef: "Aéronautique & Défense", chimie: "Chimie & Matériaux", industrie: "Industrie & Manufacturing" },
    },
    manifesto: {
      title: ["Notre façon", "de recruter"],
      chapters: [
        { n: "01", t: "L'expertise scientifique d'abord", d: "Fondée par des scientifiques, Yellow5 comprend les exigences techniques et réglementaires de vos métiers. Nous parlons votre langage." },
        { n: "02", t: "Environnements régulés uniquement", d: "GMP, ISO, HACCP, IEC. Nous opérons exclusivement là où la conformité et la précision sont non-négociables." },
        { n: "03", t: "Ingénieurs & techniciens", d: "Du terrain au comité de direction, nous couvrons l'ensemble des fonctions clés de vos environnements de haute exigence." },
      ],
    },
    latestJobs: { title: "Offres récentes", all: "Toutes les offres" },
    partners: { kicker: "Ils nous ont fait confiance", title: "Nos partenaires", yourBrand: ["Votre marque", "ici ?"], become: "Devenir partenaire" },
    ctaHome: { title: ["Un projet en tête ?"], accent: "Parlons-en.", text: "Que vous recrutiez ou que vous cherchiez votre prochain défi, notre équipe est à votre écoute.", button: "Nous contacter" },
    footer: {
      tagline: "Consultance & recrutement pour les environnements régulés. Created by scientists, driven by talents.",
      nav: "Navigation", services: "Services", about: "À propos", jobs: "Offres d'emploi", spontaneous: "Candidature spontanée", admin: "Espace admin",
      contact: "Contact", linkedin: "Suivez-nous sur LinkedIn", office: "Nos bureaux", rights: "Tous droits réservés.", specialist: "Regulated Environments Specialist",
      privacy: "Politique de confidentialité", manageCookies: "Gérer les cookies",
    },
    services: {
      kicker: "Nos services",
      title: ["Consultance &", "recrutement"],
      subtitle: "Deux expertises complémentaires pour accompagner les industries de haute exigence.",
      model: {
        intro: "Deux expertises complémentaires au service des industries à haute exigence.",
        consulting: { t: "Consultance", d: "Nous mettons à disposition des spécialistes pour vos besoins temporaires ou projets, en tant que consultants Yellow5 sous notre payroll, ou en tant que freelance." },
        recruitment: { t: "Recrutement (placement permanent)", d: "Nous identifions et intégrons la bonne personne directement dans votre équipe, sous contrat fixe." },
      },
      needTitle: "Un besoin spécifique ?",
      needText: "Parlons de votre projet et de vos enjeux de conformité.",
      contact: "Nous contacter",
      items: [
        {
          id: "life-science", label: "Life Sciences", tagline: "Pharmaceutique, biotech & medtech",
          desc: "De la conception à la production, nous vous aidons à respecter les normes réglementaires et qualité tout en améliorant l'efficacité opérationnelle.",
          list: ["QA", "QC", "QMS", "Qualified Person (QP)", "Responsible Person (Distribution)", "CSV", "Qualification & Validation", "Clinical", "Pharmacovigilance", "Regulatory Affairs", "Audits"],
        },
        {
          id: "engineering", label: "Engineering", tagline: "Chimie & matériaux, industrie & manufacturing, aéronautique & défense, agroalimentaire",
          desc: "Dans un secteur où l'optimisation des procédés et la conformité technique sont essentielles, nous proposons des profils et des services de bout en bout.",
          list: ["Concepteurs (Designers)", "Ingénieurs & Chefs de projet", "Ingénieurs R&D", "Ingénieurs Production / Maintenance", "Ingénieurs Procédés", "Gestion de projet de bout en bout", "Études de faisabilité & conformité ISO", "Mise en œuvre de procédés innovants et durables", "Analyse des risques et des exigences", "Automatisation", "Technicien de maintenance", "Électromécanicien"],
        },
      ],
    },
    about: {
      kicker: "À propos",
      title: ["Des experts", "au service des industries", "de haute exigence"],
      paragraphs: [
        "Fondée en 2022 par deux pharmaciens industriels, Yellow5 est un cabinet de conseil et de recrutement spécialisé dans les industries hautement réglementées et tournées vers l'innovation.",
        "Début 2023, un ingénieur de gestion a rejoint l'équipe pour développer nos activités et renforcer notre engagement : connecter les meilleurs talents aux organisations de premier plan.",
        "Depuis, l'équipe n'a cessé de grandir. L'entreprise réunit aujourd'hui un réseau d'une vingtaine de personnes, mêlant collaborateurs internes et freelances. Depuis 2024, Yellow5 a installé ses bureaux au LégiaPark.",
      ],
      stats: [{ k: "2022", l: "Fondation" }, { k: "~20", l: "Experts actuellement en mission" }, { k: "+5000", l: "Un réseau activable de plusieurs milliers de candidats" }, { k: "LégiaPark", l: "Nos bureaux" }],
      galleryTitle: "L'humain au cœur",
      dna: {
        kicker: "Notre ADN", title: "Cinq, comme les doigts de la main",
        paragraphs: [
          "Notre nom, Yellow5, reflète notre philosophie : Five, comme les cinq doigts de la main — symbole de collaboration, de confiance et de synergie entre nos clients et les experts que nous leur présentons.",
          "À la croisée de la technologie, de la conformité et de l'innovation, nous tendons la main comme un partenaire fiable, avec des solutions sur mesure pour soutenir vos projets les plus ambitieux et constituer la bonne équipe.",
          "Yellow5, c'est créer de la valeur en développant nos Talents dans un environnement complexe, exigeant et à haute valeur ajoutée, tout en gardant l'humain au cœur de notre organisation. Si notre cœur bat pour nos Talents, notre ADN reste la Science.",
        ],
      },
      mission: {
        kicker: "Mission & Valeurs", title: "Affronter la complexité",
        text: "Notre mission est claire : affronter la complexité de front pour garantir vos réalisations innovantes. Pour tenir cette promesse, nous nous appuyons sur des valeurs fortes.",
        values: [
          { n: "01", t: "Excellence", d: "Nous visons l'excellence dans chaque solution, en garantissant les plus hauts standards dans des environnements complexes et réglementés." },
          { n: "02", t: "Transparence", d: "La transparence façonne notre manière de travailler, instaurant confiance et clarté dans chaque collaboration." },
          { n: "03", t: "Engagement", d: "Notre engagement profond nous pousse à accompagner nos clients et nos talents avec dévouement et sens." },
          { n: "04", t: "Collaboration", d: "Nous croyons en la force de la collaboration — car le progrès naît quand expertise, innovation et humains se rencontrent." },
        ],
      },
      experts: {
        kicker: "Réseau d'experts", title: ["Ils parlent", "de nous"], desc: "Les experts parmi notre réseau témoignent de leur collaboration avec Yellow5.",
        joinTitle: "Rejoignez notre réseau de talents", joinCta: "Candidature spontanée",
        list: [
          { name: "Nicolas J.", role: "Expert CQV", quote: "Ravi d'avoir été approché par Yellow5 pour une collaboration en freelance. Après un an, plusieurs collaborations ont été menées avec succès, dont une qui débute avec le CHU de Liège. Véritable acteur local, Yellow5 excelle à connecter la bonne personne avec la bonne opportunité, avec passion, patience et constance. Leur simplicité rayonnante dans un domaine complexe fait un bien fou." },
          { name: "Anne V.", role: "Qualified Person", quote: "Y5 m'accompagne tout au long de mes projets et reste très attentif à mes préférences de mission. Une petite structure qui valorise chacun pour ses compétences et son expertise. Chez Y5, performance et satisfaction client ne sont jamais dissociées de la bienveillance." },
          { name: "Nelly S.", role: "Qualified Person, Auditrice", quote: "Un vrai plaisir de travailler avec Yellow5 : une communication claire, efficace et transparente. Une question ? Il y a toujours quelqu'un au bout du fil. Recommencer ? Absolument. Et cette attitude positive, un vrai plus." },
          { name: "Jean-Marc T.", role: "Qualified Person", quote: "Une excellente compréhension du secteur des sciences de la vie, une réactivité optimale et un suivi rigoureux des dossiers caractérisent la méthode de Yellow5. Les missions proposées sont parfaitement ciblées et adaptées aux compétences du consultant. Une collaboration extrêmement fructueuse et positive, que j'espère poursuivre." },
        ],
      },
    },
    contact: {
      kicker: "Contact", title: ["Discutons", "ensemble."],
      subtitle: "Un besoin de recrutement, une mission de consultance ou une simple question ? Notre équipe vous répond sous 48h.",
      office: "Nos bureaux", address: "LégiaPark, Boulevard Patience et Beaujonc 3, 4000 Liège",
      roles: { founder: "Fondateur", cofounder: "Co-fondateur", bdPharma: "Business Development & Recruitment Associate — Pharma / MedTech", bdEng: "Business Development & Recruitment Consultant — Engineering" },
      form: { name: "Nom complet *", email: "Email *", company: "Société", message: "Votre message *", submit: "Envoyer le message", sending: "Envoi…", successTitle: "Message envoyé", successText: "Merci, nous revenons vers vous très vite.", errRequired: "Nom, email et message requis.", ok: "Message envoyé !" },
    },
    jobs: {
      kicker: "Rejoignez-nous", title: ["Offres", "d'emploi"], allSectors: "Tous les secteurs", allProfiles: "Tous profils",
      engineer: "Ingénieur", technician: "Technicien", loading: "Chargement…",
      emptyTitle: "Aucune offre pour ce filtre", emptyText: "Tentez une candidature spontanée — nous étudions tous les profils qualifiés.",
    },
    jobDetail: { back: "Toutes les offres", description: "Description", requirements: "Profil recherché", apply: "Postuler à cette offre", notFound: "Offre introuvable.", backLink: "Retour aux offres", loading: "Chargement…" },
    apply: { kicker: "Candidature spontanée", title: ["Votre", "prochain", "défi."], text: "Aucune offre ne correspond à votre profil ? Envoyez-nous votre CV. Notre équipe l'étudie avec attention et vous recontacte dès qu'une opportunité correspond à votre profil dans les environnements régulés.", aiTitle: "Analyse intelligente du CV", aiText: "Compétences, expérience et secteur détectés automatiquement pour un matching plus rapide." },
    login: { area: "Espace admin", title: "Connexion", email: "Email", password: "Mot de passe", submit: "Se connecter", ok: "Connexion réussie", },
    appForm: { role: "Poste", name: "Nom complet *", email: "Email *", phone: "Téléphone", message: "Message (optionnel)", submit: "Envoyer la candidature", analysing: "Envoi en cours…", cvRequired: "Veuillez joindre votre CV.", nameEmail: "Nom et email requis.", successTitle: "Candidature reçue", successText: "Merci {name}. Notre équipe analyse votre profil et reviendra vers vous rapidement.", ok: "Candidature envoyée !", dropTitle: "Déposez votre CV ici ou cliquez pour parcourir", dropSub: "PDF, DOC ou DOCX · max 10 Mo" },
  },
};
